/**
 * #900 Phase 2: Pure mapping from onboarding feature ids to capability codes.
 * Separated from onboardingFeatureOverrides.ts so it can be tested in Node
 * without pulling in supabaseClient (which requires React Native modules).
 */
import {
  DEFAULT_OTHER_FEATURE_GROUPS,
  type OtherFeatureOptionId,
} from './otherFeatureCatalog';

/** Map selected feature ids → flat list of capability codes. */
export function featureIdsToCapabilityCodes(
  featureIds: readonly OtherFeatureOptionId[],
): string[] {
  const codeSet = new Set<string>();
  for (const group of DEFAULT_OTHER_FEATURE_GROUPS) {
    for (const opt of group.options) {
      if (featureIds.includes(opt.id)) {
        for (const code of opt.capability_codes) codeSet.add(code);
      }
    }
  }
  return Array.from(codeSet);
}
